import script from "./goRinSyo0060.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0060.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0060.vue?vue&type=style&index=0&id=4dfa2082&lang=scss"

const __exports__ = script;

export default __exports__